import React, {
	useCallback,
	useEffect,
	useRef,
	useState
} from 'react';

import { log } from '../../services/utils';

import { getUserProfile } from '../../api/nora/auth';

import {
	useAuthState,
	useAuthAction
} from '../../contexts/AuthContext';
import { useUIAction } from '../../contexts/UIContext';

import Alert from '../Alert';

const TimeoutModal = () => {
	const { user } = useAuthState();
	const { signOut } = useAuthAction();
	const { setNavLock } = useUIAction();

	const timeoutRef = useRef( null );

	const [ timeoutModal, setTimeoutModal ] = useState( false );

	const handleTimeoutModal = useCallback( () => {
		const warningTime = sessionStorage.getItem( 'warningTime' );
		const currentTime = new Date().getTime();

		if ( warningTime <= currentTime ) {
			setTimeoutModal( true );
		} else {
			setTimeout( () => handleTimeoutModal(), warningTime - currentTime );
		}
	}, [] );

	const handleSignOut = useCallback( () => {
		setNavLock( false );
		signOut();
	}, [
		setNavLock,
		signOut
	] );

	useEffect( () => {
		if ( !timeoutModal ) {
			const warningTime = sessionStorage.getItem( 'warningTime' );
			const currentTime = new Date().getTime();

			setTimeout( () => handleTimeoutModal(), warningTime - currentTime );
		}
	}, [
		handleTimeoutModal,
		timeoutModal
	] );

	useEffect( () => {
		if ( timeoutModal ) {
			timeoutRef.current = setTimeout( handleSignOut, 60000 * 5 );
		}
	}, [
		handleSignOut,
		timeoutModal
	] );

	const handleClose	= useCallback( async () => {
		clearTimeout( timeoutRef.current );
		await getUserProfile( user.id );
		setTimeoutModal( false );
	}, [ user.id ] );

	return (
		<>
			{ log( 'timeoutModal' ) }
			<Alert
				closeModal={ handleClose }
				closeText="Refresh"
				heading="Timeout"
				message="Your session is going to expire in 5 minutes. If you don't refresh, you will be signed out."
				name="auth-timeout-alert"
				open={ timeoutModal }
				type="warning"
			/>
		</>
	);
};

export default TimeoutModal;
